import { NotificationBodyProps } from "../ui/Notification/NotificationBody";
import { _UINotificationController } from "../ui/Notification/NotificationController";

export function openNotification(params: Omit<NotificationBodyProps, 'id'>) {
    _UINotificationController.add(params)
}